import { describeGatewayError, type GatewayError } from './gatewayError'

export const CONNECTED_METERS_LOADING_TITLE = 'טוען מדים קשורים...'

export const CONNECTED_METERS_EMPTY_TITLE = 'אין מדים קשורים'

/**
 * Related meters are derived from the water-tree balance groups of the site, so
 * a site without water trees has none. Say that, instead of leaving the user to
 * read an empty table as a failure.
 */
export const CONNECTED_METERS_EMPTY_DETAIL =
  'מדים קשורים נגזרים מקבוצות עצי המים של האתר — לאתר ללא עצי מים לא יוצגו מדים קשורים'

export const CONNECTED_METERS_ERROR_FALLBACK = 'טעינת המדים הקשורים נכשלה'

export type ConnectedMetersState =
  | { kind: 'rows' }
  | { kind: 'loading' | 'empty' | 'error'; title: string; detail?: string }

export const getConnectedMetersState = (input: {
  isLoading: boolean
  error: GatewayError | null
  rowCount: number
}): ConnectedMetersState => {
  if (input.rowCount > 0) return { kind: 'rows' }
  if (input.error) {
    return {
      kind: 'error',
      title: CONNECTED_METERS_ERROR_FALLBACK,
      detail: describeGatewayError(
        input.error,
        CONNECTED_METERS_ERROR_FALLBACK
      ),
    }
  }
  if (input.isLoading) {
    return { kind: 'loading', title: CONNECTED_METERS_LOADING_TITLE }
  }
  return {
    kind: 'empty',
    title: CONNECTED_METERS_EMPTY_TITLE,
    detail: CONNECTED_METERS_EMPTY_DETAIL,
  }
}
